import ADB from "../../../../libs/MediaSDK";
import { akamai } from "../../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { BUFFERING_CHANGE, DESTROY } = akamai.amp.Events;

class Buffering {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.subscriptions = [];
    //debug.log("[MediaAnalyticsTracking][Mute][constructor]:", this);
  }

  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;

    const bufferchange$ = amp.AmpEventsSources[BUFFERING_CHANGE].subscribe(
      (data) => {
        this.onChange(data);
      }
    );

    const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [destroy$, bufferchange$];

    if (amp.buffering === true) {
      this.onBufferingChange();
    }
  }

  onChange(data) {
    debug.log(
      "[MediaAnalyticsTracking]Buffering[onBufferingChange] data",
      data
    );
    const { amp } = this;
    const stateName = amp.buffering
      ? ADB_MEDIA_EVENTS.BufferStart
      : ADB_MEDIA_EVENTS.BufferComplete;
    debug.log(
      "[MediaAnalyticsTracking]Buffering[onBufferingChange] tracker.trackEvent \n\tstateName:",
      stateName
    );
    this.tracker.trackEvent(stateName);
  }
}

export default Buffering;
